import React from 'react';
import AppIconWithBackground from '@components/AppIconWithBackground';
import {
  Alerts,
  AlertsFull,
  Assets,
  AssetsFull,
  Findings,
  FindingsFull,
  Identities,
  IdentitiesFull,
  Incidents,
  IncidentsFull,
  Risk360,
  Risk360Full,
  Threats,
  ThreatsFull,
} from '@fabric-ui/icons/apps';
import { APP_PATHS } from '../../types';
import { App } from '../../types/sideBar.types';

const createAppIcon = (IconComponent: React.ComponentType) => ({
  icon: (
    <AppIconWithBackground
      size={32}
      bgColor="var(--color-content-immutable-white)"
      bgOpacity={0.15}
      iconColor="var(--color-content-immutable-white)"
      hoverBgColor="var(--color-content-immutable-white)"
      hoverBgOpacity={1}
      hoverIconColor="var(--color-brand-brightBlue)">
      <IconComponent />
    </AppIconWithBackground>
  ),
  iconFull: (
    <AppIconWithBackground size={32} bgColor="var(--color-content-immutable-white)" iconColor="var(--color-brand-brightBlue)">
      <IconComponent />
    </AppIconWithBackground>
  ),
});

const createDropdownIcon = (IconComponent: React.ComponentType<{ style?: React.CSSProperties }>) => (
  <IconComponent style={{ width: 32, height: 32 }} />
);

export const appsOptions: App[] = [
  {
    id: APP_PATHS.VULNERABILITIES,
    name: 'Vulnerabilities',
    description: 'Unified Vulnerability Management',
    ...createAppIcon(Findings),
    iconDropdown: createDropdownIcon(FindingsFull),
    backgroundColor: 'transparent',
    enumValue: 'VULNERABILITIES',
  },
  {
    id: APP_PATHS.DETECTIONS,
    name: 'Detections',
    description: 'Event Detections',
    ...createAppIcon(Alerts),
    iconDropdown: createDropdownIcon(AlertsFull),
    backgroundColor: 'transparent',
    enumValue: 'DETECTIONS',
  },
  {
    id: APP_PATHS.INCIDENTS,
    name: 'Incidents',
    description: 'Incident Management',
    ...createAppIcon(Incidents),
    iconDropdown: createDropdownIcon(IncidentsFull),
    backgroundColor: 'transparent',
    enumValue: 'INCIDENTS',
  },
  {
    id: APP_PATHS.RISK360,
    name: 'Risk360',
    description: 'Risk360',
    ...createAppIcon(Risk360),
    iconDropdown: createDropdownIcon(Risk360Full),
    backgroundColor: 'transparent',
    enumValue: 'RISK360',
  },
  {
    id: APP_PATHS.ASSETS,
    name: 'Assets',
    description: 'Asset Exposure Management',
    ...createAppIcon(Assets),
    iconDropdown: createDropdownIcon(AssetsFull),
    backgroundColor: 'transparent',
    enumValue: 'ASSETS',
  },
  {
    id: APP_PATHS.THREATS,
    name: 'SOC Workbench',
    description: 'Agentic SOC',
    ...createAppIcon(Threats),
    iconDropdown: createDropdownIcon(ThreatsFull),
    backgroundColor: 'transparent',
    enumValue: 'THREATS',
  },
  {
    id: APP_PATHS.IDENTITIES,
    name: 'Identities',
    description: 'Identities App',
    ...createAppIcon(Identities),
    iconDropdown: createDropdownIcon(IdentitiesFull),
    backgroundColor: 'transparent',
    enumValue: 'IDENTITIES',
  },
];
